import { OperationsBoardSetting } from '../interfaces/operations-board-settings';

export class SetSetting {
  static readonly type = '[OperationsBoardSettingState] Set Setting';
  constructor(
    public userId: string,
    public setting: OperationsBoardSetting,
  ) {}
}
